// Some commonly used functions

// show content when it is ready to interact, common for all Meteo RLPs
export function readyToInteract() {
  $('.preload-spinner-wrapper').remove();
  $('.meteo-collection-loading-wrapper').removeClass('h-element--hide');
}
